import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './Guitar.css';

// Così contiamo il capotasto sul 12:
const NOTE_POSITION = {
  // sesta corda (MI BASSO)
  'E,': { string: 1 }, //ottava 3
  'F,': { string: 1, key: 1 },
  '^F,': { string: 1, key: 2 },
  'G,': { string: 1, key: 3 },
  '^G,': { string: 1, key: 4 },
  // quinta corda:
  'A,': { string: 2 }, // A3 OTTAVA 3, inizio range da supportare.
  '^A,': { string: 2, key: 1 },
  '_B,': { string: 2, key: 1 },
  'B,': { string: 2, key: 2 },
  C: { string: 2, key: 3 },
  '^C': { string: 2, key: 4 },
  // quarta corda:
  D: { string: 3 },
  '^D': { string: 3, key: 1 },
  E: { string: 3, key: 2 },
  F: { string: 3, key: 3 },
  '^F': { string: 3, key: 4 },
  // terza corda:
  G: { string: 4 },
  '^G': { string: 4, key: 1 },
  A: { string: 4, key: 2 },
  '^A': { string: 4, key: 3 },

  B: { string: 5 },
  c: { string: 5, key: 1 },
  '^c': { string: 5, key: 2 },
  // quarta corda:
  d: { string: 5, key: 3 },
  '^d': { string: 5, key: 4 },
  e: { string: 6 },
  f: { string: 6, key: 1 },
  '^f': { string: 6, key: 2 },
  // terza corda:
  g: { string: 6, key: 3 },
  '^g': { string: 6, key: 4 },
  a: { string: 6, key: 5 }, // A5 OTTAVA 5, fine range da supportare.
  '^a': { string: 6, key: 6 },
  b: { string: 6, key: 7 }
};

const KEY_POSITION = [-10, 45, 100, 155, 200, 235];
const STRING_POSITION = [-10, 10, 28, 47, 65, 83, 102];

class Guitar extends PureComponent {
  static propTypes = {
    currentNote: PropTypes.object,
    debug: PropTypes.bool
  };

  getFret = note => {
    const abcString = note ? note.toAbcString() : null;
    const position = abcString ? NOTE_POSITION[abcString] : null;
    const stringNumber = position && position.string ? position.string : 0;
    const keyNumber = position && position.key ? position.key : 0;
    return { stringNumber, keyNumber };
  };

  renderSvg = note => {
    const { stringNumber, keyNumber } = this.getFret(note);
    const cx = KEY_POSITION[keyNumber]; // 103.7
    const cy = STRING_POSITION[stringNumber]; // 10
    const selectedStringColor = '#FF5073';
    return (
      <svg
        version="1.1"
        id="Guitar"
        x="0px"
        y="0px"
        viewBox="0 0 518.3 133.7"
        style={{ enableBackground: 'new 0 0 518.3 133.7' }}
      >
        <g id="Group_164" transform="translate(0 0.5)">
          <rect id="Rectangle_287" x="0.5" y="2.7" className="st0" width="517.8" height="115.3" />
          <line id="Line_160" className="st1" x1="75.9" y1="3.1" x2="75.9" y2="107.6" />
          <line id="Line_161" className="st2" x1="13.8" y1="8.7" x2="13.8" y2="102.5" />
          <line id="Line_163" className="st1" x1="127.9" y1="3.1" x2="127.9" y2="107.6" />
          <line id="Line_164" className="st1" x1="179.9" y1="3.1" x2="179.9" y2="107.6" />
          <line id="Line_165" className="st1" x1="217.5" y1="3.1" x2="217.5" y2="107.6" />
          <line id="Line_161_1_" className="st1" x1="255.1" y1="3.1" x2="255.1" y2="107.6" />
          <line id="Line_162_1_" className="st1" x1="292.7" y1="3.1" x2="292.7" y2="107.6" />
          <line id="Line_163_1_" className="st1" x1="330.3" y1="3.1" x2="330.3" y2="107.6" />
          <line id="Line_164_1_" className="st1" x1="367.9" y1="3.1" x2="367.9" y2="107.6" />
          <line id="Line_165_1_" className="st1" x1="405.5" y1="3.1" x2="405.5" y2="107.6" />
          <line id="Line_165_2_" className="st1" x1="443.1" y1="3.1" x2="443.1" y2="107.6" />
          <line id="Line_165_3_" className="st1" x1="480.7" y1="3.1" x2="480.7" y2="107.6" />
          <line id="Line_165_4_" className="st1" x1="518.3" y1="3.1" x2="518.3" y2="107.6" />
          <line
            id="Line_167"
            className="st3"
            x1="518.3"
            y1="9.5"
            x2="13.8"
            y2="9.5"
            stroke={stringNumber === 1 ? selectedStringColor : '#000000'}
          />
          <line
            id="Line_168"
            className="st3"
            x1="518.3"
            y1="28.1"
            x2="13.8"
            y2="28.1"
            stroke={stringNumber === 2 ? selectedStringColor : '#000000'}
          />
          <line
            id="Line_169"
            className="st4"
            x1="518.3"
            y1="46.4"
            x2="13.8"
            y2="46.4"
            stroke={stringNumber === 3 ? selectedStringColor : '#000000'}
          />
          <line
            id="Line_170"
            className="st4"
            x1="518.3"
            y1="64.9"
            x2="13.8"
            y2="64.9"
            stroke={stringNumber === 4 ? selectedStringColor : '#000000'}
          />
          <line
            id="Line_171"
            className="st5"
            x1="518.3"
            y1="83.4"
            x2="13.8"
            y2="83.4"
            stroke={stringNumber === 5 ? selectedStringColor : '#000000'}
          />
          <line
            id="Line_172"
            className="st2"
            x1="518.3"
            y1="101.8"
            x2="13.8"
            y2="101.8"
            stroke={stringNumber === 6 ? selectedStringColor : '#000000'}
          />
          <path
            className="st6"
            d="M405.5,107.6H13.8v10.7l392.5-0.3c14.7,0,28.1,5.8,38,15.2h74v-25.6C518.3,107.6,405.5,107.6,405.5,107.6z"
          />

          <rect
            id="Rectangle_292"
            x="149.9"
            y="51.9"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 5.5412 125.2058)"
            className="st7"
            width="8"
            height="8"
          />

          <rect
            id="Rectangle_292_1_"
            x="232.4"
            y="51.9"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 29.7175 183.5286)"
            className="st7"
            width="8"
            height="8"
          />

          <rect
            id="Rectangle_292_2_"
            x="307.6"
            y="51.9"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 51.7449 236.7006)"
            className="st7"
            width="8"
            height="8"
          />

          <rect
            id="Rectangle_292_3_"
            x="382.8"
            y="51.9"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 73.7722 289.8726)"
            className="st7"
            width="8"
            height="8"
          />

          <rect
            id="Rectangle_292_4_"
            x="495.6"
            y="33.4"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 119.9131 364.2305)"
            className="st7"
            width="8"
            height="8"
          />

          <rect
            id="Rectangle_292_5_"
            x="495.6"
            y="70.6"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 93.5859 375.1031)"
            className="st7"
            width="8"
            height="8"
          />
          <rect id="Rectangle_288" x="0.5" y="2.7" className="st8" width="13.3" height="104.9" />
          <rect id="Rectangle_288_1_" x="0.5" y="107.6" className="st9" width="13.3" height="10.4" />
        </g>
        {cx >= 0 && cy >= 0 && <circle className="st10" cx={cx} cy={cy} r="10" />}
      </svg>
    );
  };

  renderDebug = note => {
    const fret = this.getFret(note);
    return fret.stringNumber ? (
      <div>
        String: {fret.stringNumber} - Key: {fret.keyNumber}
      </div>
    ) : (
      <div> NOTA NON DISPONIBILE </div>
    );
  };

  render() {
    const { currentNote, debug } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        {debug && this.renderDebug(currentNote)}
        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
          {this.renderSvg(currentNote)}
        </div>
      </div>
    );
  }
}

export default Guitar;
